import React, { Fragment, useState, useEffect } from "react";
import Invoices from "./Invoices";
import styled from "styled-components";
import Button from "../Button";
import Link from "../Link";
import _ from "underscore";
import { fetchJson, post } from "../../lib/Fetching";
import AutoAddSampleCharges from "./AutoAddSampleCharges";

const Container = styled.div`
  padding: 10px;
  padding-left: 20px;
  max-width: 1200px;
`;

export default function AddSampleChargesToInvoice({
  selectedSamples,
  reloadData,
  laboratoryCompanyId,
}) {
  const [message, setMessage] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [invoices, setInvoices] = useState(null);
  const [inProgress, setInProgress] = useState(false);
  const [autoAdd, setAutoAdd] = useState(false);

  const _baseUrl = () => {
    return window.location.protocol + "//" + window.location.host;
  };

  const companyIds = _.uniq(selectedSamples.map((s) => s.company_id));

  const loadInvoices = () => {
    if (selectedSamples.length === 0) {
      setInvoices(null);
      setMessage(null);
      return;
    }

    if (companyIds.length == 1) {
      fetchJson("/invoicing/invoices.json", {
        company_id: companyIds[0],
        laboratory_company_id: laboratoryCompanyId,
      }).then((json) => {
        setInvoices(json.invoices);
        setMessage(null);
      });
    }
    if (companyIds.length > 1) {
      setMessage("The selected samples belong to more than one company.");
      setInvoices(null);
    }
    if (companyIds.length === 0) {
      setInvoices(null);
      setMessage(null);
    }
  };

  useEffect(
    () => {
      loadInvoices();
    },
    [companyIds.join(".")]
  );

  const addChargeToInvoice = () => {
    if (!selectedInvoice || selectedSamples.length === 0) return;
    setInProgress(true);

    post("/invoicing/invoices/" + selectedInvoice.id + "/add_ledger_items_to_invoice", {
      ledger_item_ids: selectedSamples.map((s) => s.ledger_item_id),
      id: selectedInvoice.id,
    })
      .then((json) => {
        alert("Successfully added to invoice " + selectedInvoice.id);
        reloadData();
        setInProgress(false);
      })
      .catch((error) => alert(error));
  };

  return (
    <Container>
      {message && <div className="alert alert-danger">{message}</div>}
      {invoices && (
        <Fragment>
          <h4>Active Invoices</h4>
          <p>
            <Button title="Reload Invoices" onClick={loadInvoices} icon="fa-refresh" tiny />
            <Button
              title="Automatically Add Samples to Invoices"
              onClick={() => setAutoAdd(true)}
              tiny
            />
          </p>
          {autoAdd && <AutoAddSampleCharges selectedSamples={selectedSamples} />}
          {invoices.length > 0 && (
            <Fragment>
              <Invoices
                invoices={invoices}
                selectedIds={selectedInvoice ? [selectedInvoice.id] : []}
                canSelect
                onSelect={(invoice, checked) => {
                  console.log("Hello", invoice);
                  setSelectedInvoice(invoice);
                }}
              />
              <p>{selectedSamples.length} charges have been selected.</p>
              <Button
                title={inProgress ? "Loading..." : "Add To Invoice"}
                onClick={addChargeToInvoice}
                disabled={!selectedInvoice || inProgress}
                icon={inProgress ? "fa-refresh" : null}
                primary
              />
            </Fragment>
          )}
          {invoices.length == 0 && (
            <Fragment>
              <p>There are no active invoices for this client.</p>
            </Fragment>
          )}
        </Fragment>
      )}
    </Container>
  );
}
